import { render, staticRenderFns } from "./AgeVerificationController.vue?vue&type=template&id=57903565&"
import script from "./AgeVerificationController.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports